export const colors = {
  main: "#72B7BC",
  main_gradient: "linear-gradient(180deg, #72B7BC 0%, #FFFFFF 100%)",
  dark_gray: "#828282",
  light_gray: "#E6E6E6",
  light_black: "#0D2233",
  red: "#DF1545",
};
